import React, { useCallback, useState } from 'react';
import ConfirmDialog from '@/components/ConfirmDialog';

/**
 * Onay penceresi hook'u — native window.confirm() yerine.
 *
 * Kullanım:
 *   const { confirm, confirmDialog } = useConfirm();
 *
 *   confirm({
 *     title: 'Silinsin mi?',
 *     description: 'Bu işlem geri alınamaz.',
 *     destructive: true,
 *     onConfirm: async () => { ... },
 *   });
 *
 *   // render'ın sonuna: {confirmDialog}
 */
export default function useConfirm() {
  const [config, setConfig] = useState(null);

  const confirm = useCallback((options) => setConfig(options), []);

  const handleConfirm = () => {
    const action = config?.onConfirm;
    setConfig(null);
    if (action) action();
  };

  const confirmDialog = (
    <ConfirmDialog
      open={Boolean(config)}
      onOpenChange={(open) => !open && setConfig(null)}
      title={config?.title || ''}
      description={config?.description}
      confirmLabel={config?.confirmLabel || 'Onayla'}
      cancelLabel={config?.cancelLabel || 'Vazgeç'}
      destructive={config?.destructive}
      onConfirm={handleConfirm}
    />
  );

  return { confirm, confirmDialog };
}
